export class GameOptionView {
  buttonSettingsPlayer = document.getElementById(
    'buttonSettingsPlayer',
  );
  buttonSettingsTime = document.getElementById('buttonSettingsTime');
  buttonsSettingsChampions = document.querySelectorAll(
    '.selected-time',
  );
  buttonPlay = document.getElementById(
    'buttonPlay',
  )! as HTMLButtonElement;

  buttonsChampions = document.querySelectorAll('.champion');
}
